<div *transloco="let t" class="flex flex-col gap-4">
  <div class="type-body text-muted-foreground">
    {{ t("dsp-create-audiences-result.some_audiences_could_not_be_created") }}
  </div>
  @if (erroredAudiences && erroredAudiences.length > 0) {
    <IAlert [title]="t('dsp-create-audiences-result.audience_not_created')" type="error" [collapsable]="false">
      <ul class="list-disc pl-4">
        @for (audience of erroredAudiences; track $index) {
          <li>{{ audience.audienceName }}</li>
        }
      </ul>
    </IAlert>
  }
  @if (createdAudiences && createdAudiences.length > 0) {
    <IAlert
      [title]="t('dsp-create-audiences-result.successfully_created_audiences')"
      type="success"
      [collapsable]="false"
    >
      <ul class="list-disc pl-4">
        @for (audience of createdAudiences; track $index) {
          <li>{{ audience.audienceName }}</li>
        }
      </ul>
    </IAlert>
  }
  <div class="flex justify-end">
    <button iButton size="md" (click)="close()">{{ t("common.i_understand") }}</button>
  </div>
</div>
